import { render, staticRenderFns } from "./newPage1.vue?vue&type=template&id=77af78ac&scoped=true"
import script from "./newPage1.vue?vue&type=script&lang=js"
export * from "./newPage1.vue?vue&type=script&lang=js"
import style0 from "./newPage1.vue?vue&type=style&index=0&id=77af78ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77af78ac",
  null
  
)

export default component.exports